import React from 'react'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import TechnologyHead from '../techComponent/TechnologyHead'
import TechnologyNex from '../techComponent/TechnologyNex';

const breadcrumbData = [
  {
    page: "Home",
    slug: "/",
  },
  {
    page: "Technologies",
    slug: "",
  },
  {
    page: "IOT Enabled System",
    slug: "",
  }
]

const techData ={
  label: "Technologies",
  heading: "IOT-Enabled Systems: Smart, Secure & Automated document management for real-time Tracking & Enhanced Efficiency",
  img: "/assets/images/iot.webp",
  alt: "iot",
  description: `
    <p>Management and Preservation of records can be tricky and challenging even for record management companies like us if we don't have the proper systems and technologies in place. With IOT-Enabled, Automated, and Tracking & Enhanced records and data preservation systems, there are huge risks involved like mismanagement of data while relocating to offsite storage facilities, wrong indexing, and barcoding, which can result in permanent damage of records regardless of their sensitivity and priority. Managing bulk records has risk at various stages of their record management lifecycle.</p>

    <p>The best way to mitigate risks in such a situation is to use IoT enabled systems. The IoT enabled systems to let you have real-time access to everything in terms of your records and data management. IoT enabled systems are viable to be used for every sector such as healthcare, legal, finance, renewable energy, FMCG, electronics. Efficient and mistake proof records and data can be assured with the use of IoT systems coupled with a high level of security.</p>

    <h2>Smart Solutions</h2>
    <p>The advantages of IoT enabled services from DOX and Box are as follows: -</p>

    <ul>
      <li><b>Real-Time Access:</b> You can check the location, status of all records and data stored at any location anytime.</li>

      <li><b>Intelligent Categorization:</b>  We can provide you with an intelligent classification of data and records based on constant access to documents.</li>

      <li><b>Efficient Management:</b> IoT enabled services to assure risk-free and efficient management of records and data at all given points of time.</li>

      <li><b> Higher Visibility:</b> With IoT enabled systems, you have better access and visibility to the data and records</li>

      <li><b>Eliminate Manual Labor:</b>  Use of IoT enabled systems eliminates the need for manual labor and mistakes associated with it.</li>

      <li><b>Secure and Safe Storage:</b>  With Higher visibility and instant access, IOT enabled services to guarantee safe and secure storage of data and records.</li>
    </ul>

    <p>With the rising increase in technology and digitization, records management and the companies dealing with these services have to pull up their games and increase their efficiency with each passing day. Another technology that comes paired with IoT enabled services is Radiofrequency Identification Tags ( RFID). The RFID tags coupled with computer-enabled software can help you to keep real-time track of all records and data, temperature, humidity of the storage facilities.</p>

    <p>Technology is meant to be used for the better of mankind and ease their work and life in every possible manner. IoT enabled services make the heavy task of records management to be done with ease and zero mistakes. We have a very professional IOT enabled team in place to manage all the tasks of any client.</p>
  `
};

const techNextData = [
  {
    img: "assets/images/data-analytics.webp",
    title: "Data & Analytics",
    slug:"/data-analytics"
  },
  {
    img: "/assets/images/iot-cloud.webp",
    title: "Cloud Computing",
    slug:"/cloud-computing"
  },
];

export default function Iot() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <TechnologyHead data={techData}/>
      <TechnologyNex technex = {techNextData} />
    </>
  )
}
